export default "__VITE_ASSET__ed755cfb__"